import React from 'react';
import Typography from 'antd/es/typography';
import { CalendarOutlined, HeartOutlined, BookOutlined } from '@ant-design/icons';
import { Row, Col, Divider } from 'antd';
import Card from 'antd/es/card';

const { Title, Paragraph, Text } = Typography;

const Home: React.FC = () => {
  return (
    <div style={{ 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px'
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* 头部区域 */}
        <Card 
          style={{ 
            marginBottom: '20px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
            borderRadius: '12px'
          }}
        >
          <div style={{ textAlign: 'center' }}>
            <Title level={1} style={{ margin: 0, color: '#1890ff', marginBottom: '16px' }}>
              <HeartOutlined style={{ marginRight: '12px' }} />
              贝塔的生活日记
            </Title>
            <Paragraph style={{ fontSize: '18px', lineHeight: '1.6', marginBottom: '32px', color: '#666' }}>
              记录生活中的美好瞬间，分享成长的点滴感悟
            </Paragraph>
          </div>
        </Card>

        {/* 日记内容区域 */}
        <Row gutter={[20, 20]}>
          <Col xs={24} lg={16}>
            <Card 
              title={
                <span>
                  <BookOutlined style={{ marginRight: '8px' }} />
                  最新日记
                </span>
              }
              style={{ 
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                borderRadius: '12px'
              }}
            >
              <div style={{ marginBottom: '24px' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                  <CalendarOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
                  <Text strong style={{ color: '#1890ff' }}>2025年8月13日 星期三</Text>
                </div>
                <Title level={4} style={{ margin: '12px 0', color: '#333' }}>
                  冬日暖阳下的思考
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: '1.8', color: '#555' }}>
                  今天是个难得的好天气，阳光透过窗户洒在书桌上，温暖而明亮。在这样的日子里，我总喜欢坐在窗边，捧着一本书，享受这份宁静。
                  <br /><br />
                  最近在读一本关于心理健康的书籍，让我对生活有了新的认识。每个人都会遇到困难和挫折，但重要的是如何面对它们。保持积极的心态，学会调节情绪，这些都是我们成长路上必不可少的技能。
                  <br /><br />
                  下午去公园散步，看到很多人在锻炼身体，孩子们在玩耍，老人们在下棋。这样的场景让我感到生活的美好。健康的身心是我们最宝贵的财富，我们应该好好珍惜。
                </Paragraph>
              </div>

              <Divider />

              <div style={{ marginBottom: '24px' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                  <CalendarOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
                  <Text strong style={{ color: '#1890ff' }}>2025年6月23日 星期一</Text>
                </div>
                <Title level={4} style={{ margin: '12px 0', color: '#333' }}>
                  与朋友的深度对话
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: '1.8', color: '#555' }}>
                  今天和多年未见的老朋友见面了。我们聊了很多，从工作到生活，从过去到现在，再到对未来的规划。
                  <br /><br />
                  朋友分享了她最近遇到的一些困扰，我能够感受到她的焦虑和不安。这让我想到，其实每个人都有自己的烦恼，重要的是要学会倾听和表达。有时候，一个真诚的拥抱或者一句温暖的话语，就能给人带来莫大的安慰。
                  <br /><br />
                  我们约定要经常联系，互相支持。友谊是人生中最珍贵的财富之一，我们应该好好维护。
                </Paragraph>
              </div>

              <Divider />

              <div>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                  <CalendarOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
                  <Text strong style={{ color: '#1890ff' }}>2025年6月10日 星期二</Text>
                </div>
                <Title level={4} style={{ margin: '12px 0', color: '#333' }}>
                  学习新技能的感受
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: '1.8', color: '#555' }}>
                  最近开始学习一门新的编程语言，虽然刚开始有些困难，但慢慢找到了感觉。学习新东西总是让人兴奋的，特别是当你能够用新学到的知识解决实际问题的时候。
                  <br /><br />
                  这个过程让我明白，学习是一个循序渐进的过程，不要急于求成。每个人都有自己的学习节奏，重要的是保持耐心和坚持。失败是成功之母，每一次的挫折都是成长的机会。
                  <br /><br />
                  明天要继续加油，相信通过不断的努力，一定能够掌握这门技能。
                </Paragraph>
              </div>
            </Card>
          </Col>

          <Col xs={24} lg={8}>
            <Card 
              title="关于贝塔"
              style={{ 
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                borderRadius: '12px'
              }}
            >
              <Paragraph style={{ fontSize: '16px', lineHeight: '1.8', color: '#555' }}>
                贝塔是一个热爱生活、喜欢记录和分享的人。通过这个日记网站，希望能够记录生活中的美好瞬间，分享成长的点滴感悟。
                <br /><br />
                这里不仅有个人生活的记录，也希望能够为读者提供一些关于心理健康、生活感悟的分享。每个人都有自己的故事，每个故事都值得被倾听。
              </Paragraph>
            </Card>
          </Col>
        </Row>
        
        {/* 备案信息 */}
        <div style={{ 
          textAlign: 'center', 
          marginTop: '40px', 
          padding: '20px 0',
          borderTop: '1px solid rgba(255, 255, 255, 0.2)'
        }}>
          <Text 
            style={{ 
              color: 'rgba(255, 255, 255, 0.8)', 
              fontSize: '14px',
              cursor: 'pointer',
              textDecoration: 'underline'
            }}
            onClick={() => window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank')}
          >
            备案信息：浙ICP备2025167490号-1
          </Text>
        </div>
      </div>
    </div>
  );
};

export default Home; 